import { createEvent } from 'effector';
import { DEFAULT_INIT_TABLE_STATE_PAGING, PAGING_LIMIT_DEFAULT_OPTIONS } from '../../consts';
import { IDataTableState, TStateStoreReducer } from '../../models';
import { isEqual } from 'lodash';

type TPayload = Partial<IDataTableState>;
type TReducer = TStateStoreReducer<TPayload>;

export const initStateEvent = createEvent<TPayload>();
export const initStateReducer: TReducer = (state, initState) => {
  if (!initState || isEqual(initState, state)) {
    return state;
  }

  return {
    paging: { ...DEFAULT_INIT_TABLE_STATE_PAGING, ...initState?.paging },
    ordering: [...(initState?.ordering || [])],
    pagingOptions: [...(initState.pagingOptions || PAGING_LIMIT_DEFAULT_OPTIONS)],
  };
};
